import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdditionalChargeService, IncidentsService } from '../../../services';
import { VmeCommonModule } from '../../../vme-common.module';
import { MessageService, SelectItem } from 'primeng';
import { IDropdownItem } from 'src/app/interfaces/drop-down-item';
import {
  VMEAdditionalCharge,
  InternalRequestVMEAdditionalChargeDTO,
} from 'src/app/interfaces/screen-specific/job-screen';

@Component({
  selector: 'additional-internal-request',
  styleUrls: ['./additional-internal-request.component.scss'],
  templateUrl: './additional-internal-request.component.html',
  standalone: true,
  imports: [VmeCommonModule],
})
export class AdditionalInternalRequestComponent implements OnInit {
  @Input() additionalCharge: VMEAdditionalCharge;
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSuccess = new EventEmitter<void>();

  isLoading: boolean;
  isSending: boolean;

  assignees: IDropdownItem[];
  assigneesOptions: SelectItem[];

  assignUserId: string;
  comment: string;

  constructor(
    private additionalChargeService: AdditionalChargeService,
    private incidentsService: IncidentsService,
  ) {}

  async loadAssignees() {
    await this.incidentsService.getAssignees().then((result) => {
      this.assignees = result;
      this.assigneesOptions = result
        .sort((a, b) => a.label.trim().localeCompare(b.label.trim()))
        .map((x) => <SelectItem>{ value: x.value.id, label: x.label });
    });
  }

  async ngOnInit() {
    this.isLoading = true;
    await this.loadAssignees();
    this.isLoading = false;
  }

  raiseAnIncident() {
    this.isSending = true;
    const internalRequestDTO = {
      assignUserId: this.assignUserId,
      comment: this.comment,
      ...this.additionalCharge,
    } as InternalRequestVMEAdditionalChargeDTO;
    this.additionalChargeService
      .sendIternalRequest(internalRequestDTO)
      .then((x) => {
        this.onSuccess.emit();
        this.closeDialog();
      })
      .catch(() => {})
      .finally(() => {
        this.isSending = false;
      });
  }

  setReassignUser(event) {
    this.assignUserId = event.value;
  }

  closeDialog() {
    this.visibleChange.emit(false);
  }
}
